import Quill from "quill";
import { cosUploadFile } from "@saas/components/src/utils/cos-upload";
import { getUploadSignature } from "@saas/service-api/src/material/index.js";
import { getCdnUrl } from "@saas/components/src";

const BlockEmbed = Quill.import("blots/block/embed");

class AudioBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    const audio = document.createElement("audio");
    audio.src = value;
    audio.controls = true;
    audio.style.margin = "5px 0";
    node.appendChild(audio);
    return node;
  }

  static value(node) {
    return node.querySelector("audio").src;
  }
}

AudioBlot.blotName = "audio";
AudioBlot.tagName = "div";
Quill.register({
  "formats/audio": AudioBlot,
});
export const uploadAudio = async (file, callback) => {
  getUploadSignature({
    fileName: file.name,
    materialType: 101,
  }).then((res) => {
    if (res.code === 1) {
      file.cos = cosUploadFile(
        {
          file: file,
          fileName: file.name,
          type: 101,
        },
        {
          ...res.data,
        },
        {
          onFileFinish: (err, data, options) => {
            if (data && data.statusCode === 200) {
              const location = data.Location;
              const arr = location.split("/");
              arr.shift();
              const url = getCdnUrl("/" + arr.join("/"));
              callback(url);
            } else {
              console.log(err);
            }
          },
        }
      );
    }
  });
};
// 上传文件
const onUploadFile = (file, quill, vue) => {
  uploadAudio(file, (url) => {
    console.log("data", url);
    const range = quill.getSelection();
    quill.insertEmbed(range.index, "audio", url);
    quill.setSelection(range.index + 1);
  });
  vue.$refs.fileInput.value = "";
};
export const registerAudioFeature = (quill, vue) => {
  const toolbar = quill.getModule("toolbar");
  const audioSelect = toolbar.container.querySelector(".ql-audio");
  // 移除第一个选项的选中class, 不然的话会第一次点击第一个选项的时候不会触发handler事件
  if (audioSelect) {
    const qlPickerItem = audioSelect.querySelector(".ql-picker-item");
    qlPickerItem?.classList?.remove("ql-selected");
  }
  // 监听上传
  console.log(vue.$refs.fileInput);
  vue.$refs.fileInput.addEventListener("change", function (event) {
    // 处理文件上传逻辑
    const file = event.target.files[0];
    // 判断格式
    if (file.type === "audio/mpeg") {
      onUploadFile(file, quill, vue);
    } else {
      vue.$message.error("请上传mp3格式文件");
    }
  });
  toolbar.addHandler("audio", function (type) {
    // 移动端会自动唤起键盘
    vue.$refs?.quill?.quill?.blur();
    // 校验是否超出文本限制
    if (!vue.judgeExceedTextLimit()) {
      vue.$emit("show-record-audio");
    }

    // if (type === "record") {
    //   // 录音
    //   vue.$emit("show-record-audio");
    // } else if (type === "upload") {
    //   // 上传录音文件
    //   vue.uploadFormat = "audio/mpeg, .mp3";
    //   vue.$nextTick(() => {
    //     console.log("准备触发文件选择框");
    //     vue.$refs.fileInput.click();
    //     console.log("文件选择框点击事件已触发");
    //   });
    // }
  });
};
